@switch (status) {
    @case (PersonalDataRequestStatusEnum.created) {
        <i class="fa fa-circle-dot icon-status icon-status_created" aria-hidden="true"></i>
    }
    @case (PersonalDataRequestStatusEnum.readByUser) {
        <i class="fa fa-adjust icon-status icon-status_read-by-user" aria-hidden="true"></i>
    }
    @case (PersonalDataRequestStatusEnum.requestSubmitted) {
        <i class="fa fa-circle icon-status icon-status_request-submited" aria-hidden="true"></i>
    }
    @case (PersonalDataRequestStatusEnum.archived) {
        <i class="fa fa-archive icon-status icon-status_archive" aria-hidden="true"></i>
    }
}
